import HackleCore from "../../../../core/HackleCore"
import {
  InAppMessageActionViewEvent,
  InAppMessageViewEvent,
  InAppMessageImageImpressionViewEvent
} from "./InAppMessageViewEvent"
import { HackleEvent, Properties } from "../../../../core/internal/model/model"
import { InAppMessagePresentationContext } from "../../present/presentation/InAppMessagePresentationContext"

export class InAppMessageEventTracker {
  constructor(private readonly core: HackleCore) {}

  track(context: InAppMessagePresentationContext, event: InAppMessageViewEvent): void {
    const hackleEvent = this.createTrackEvent(event, context)
    this.core.track(hackleEvent, context.user, event.timestamp)
  }

  private commonProperties(context: InAppMessagePresentationContext): Properties {
    return {
      ...context.properties,
      in_app_message_id: context.inAppMessage.id,
      in_app_message_key: context.inAppMessage.key,
      in_app_message_display_type: context.message.layout.displayType,
      decision_reason: String(context.decisionReason)
    }
  }

  private createTrackEvent(event: InAppMessageViewEvent, context: InAppMessagePresentationContext): HackleEvent {
    switch (event.type) {
      case "IMPRESSION":
        return {
          key: "$in_app_impression",
          properties: {
            ...this.commonProperties(context),
            title_text: context.message.text?.title?.text,
            body_text: context.message.text?.body?.text,
            button_text: context.message.buttons.map((it) => it.text),
            image_url: context.message.images.map((it) => it.imagePath)
          }
        }
      case "CLOSE":
        return {
          key: "$in_app_close",
          properties: this.commonProperties(context)
        }
      case "ACTION":
        const actionEvent = event as InAppMessageActionViewEvent
        return {
          key: "$in_app_action",
          properties: {
            ...this.commonProperties(context),
            action_type: actionEvent.action.type,
            action_area: actionEvent.area,
            action_value: actionEvent.action.value,
            button_text: actionEvent.buttonText,
            image_url: actionEvent.imageUrl,
            image_order: actionEvent.imageOrder,
            element_id: actionEvent.elementId
          }
        }
      case "IMAGE_IMPRESSION":
        const imageImpressionEvent = event as InAppMessageImageImpressionViewEvent
        return {
          key: "$in_app_image_impression",
          properties: {
            ...this.commonProperties(context),
            image_url: imageImpressionEvent.imageUrl,
            image_order: imageImpressionEvent.imageOrder
          }
        }
    }
  }
}
